import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { logout, reset } from '_redux/slices/main-screen/user';

const LogoutButton = ({
  variant = "outline-secondary",
  size = "sm",
  className = "text-muted",
  disabled = false,
  children = "Logout",
  onLogoutSuccess = null,
  onLogoutError = null
}) => {
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      // Reset user slice to clear all user data
      dispatch(reset());

      // Call success callback if provided
      if (onLogoutSuccess) {
        onLogoutSuccess();
      } else {
        // Default redirect to home page
        window.location.href = '/';
      }
    } catch (error) {
      console.error('Error during logout:', error);

      // Call error callback if provided
      if (onLogoutError) {
        onLogoutError(error);
      }
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleLogout}
      disabled={disabled}
      className={className}
    >
      {children}
    </Button>
  );
};

export default LogoutButton;
